import React from 'react'
import './Home.css'
import { Container } from 'react-bootstrap'
const AboutHome = () => {
  return (
    <section className="_emtabout corp-hidden">
      <Container>
        <div className="_ininety">
          <div className="_Genttl">
            <span>
              Search Flights
            </span>
          </div>
          <div className="_abt_txt">
            VolarPro is one of the fastest-growing online travel platforms in Guyana, and a trusted name among modern-day travelers. We specialize in providing hassle-free flight booking services with competitive pricing and reliable support.
          </div>
          <div className="_abt_txt">
            We know that organizing a trip can be time-consuming and stressful, so VolarPro is designed to simplify your air travel from start to finish. Our intuitive platform offers a wide range of flight options tailored to your preferences—whether you’re flying for a family holiday, an adventurous solo trip, or a business visit.
          </div>
          <div className="_abt_txt">
            At VolarPro, transparency and customer satisfaction are at the heart of what we do. There are no hidden charges—our pricing is upfront and competitive. With VolarPro, you can rest assured that you’re getting the best airfare deals available.
          </div>
          <div className="_abt_txt">
            If you're searching for a reliable, affordable, and hassle-free way to book your next flight, choose VolarPro. Let us make your journey smooth, simple, and unforgettable.
          </div>
        </div>
      </Container>
    </section>

  )
}

export default AboutHome